<template>
  <v-app>
    <Navbar />

    <v-sheet>
      <v-tabs height="30"
          v-if="isTeacher || isManager"
          v-model="active_tab"

      >
        <v-tab v-for="item in $store.getters.getTabList"
               :key="item.mstCd"
               :to="{ name: item.name }"
               @click="changeTab(item.mstCd)"
        >{{ item.label }}</v-tab>
      </v-tabs>
    </v-sheet>

    <transition name="fade" mode="out-in"  >

        <keep-alive :include="$store.getters.getCachedPages">
          <router-view :key="key" v-slot="{ Component }">
            <component ref="page" :is="Component" :key="$route.fullPath"/>
          </router-view>
        </keep-alive>
    </transition>

    <Footer/>

    <NavDrawer @setActiveTab="setActiveTab" />
  </v-app>
</template>
<script>
import Navbar from '@/layout/Navbar'
import NavDrawer from '@/layout/NavigationDrawer'
import Footer from '@/layout/Footer'
import { mapActions, mapGetters } from "vuex";
import { loadLanaguageAsync } from "@/locales/i18n";

export default {
  name: 'Layout',
  components: {
    Navbar,
    NavDrawer,
    Footer
  },
  data(){
    return {
      tab: [],
      searchQuery: [],
      active_tab: '',
      selectedLanguage: this.$i18n.locale,
      languages: [
        { text: '한국어', value: 'ko' },
        { text: 'English', value: 'en' }
      ]
    }
  },
  computed: {
    ...mapGetters(['app', 'menu', 'user', 'register', 'isManager', 'isTeacher','isMobile']),
    key() {
      return this.$route.name
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)

    const darkThemeMq = window.matchMedia("(prefers-color-scheme: light)")
    if (darkThemeMq.matches) {
      this.$vuetify.theme.dark = false
    } else {
      // this.$vuetify.theme.dark = true
    }

    let userLocale = navigator.languages ? navigator.languages[0] : navigator.lang
    userLocale = userLocale.substring(0,2) === 'ko' ? 'ko' : 'en'
    // userLocale = 'en'
    loadLanaguageAsync(userLocale)

    this.handleResize()
  },
  mounted() {
    this.setCdnUrl()
    this.fetchSysConfEn9door()
    if (this.user.accountId == null){
      this.logout()
    } else {
      this.searchQuery.studentId = this.user.accountId

      this.fetchUser()
    }
  },
  methods: {
    ...mapActions([
      'fetchSysConfEn9door',
      'fetchUser', 'logout', 'closeSideBar', 'toggleSideBar', 'resizeWidth',
        'setCdnUrl'
    ]),
    showMenuOfRole(menuRole){
      return this.user.accountRoles != null
          ? this.user.accountRoles.map(ar => ar.roleType).includes(menuRole)
          : false
    },
    changeTab(tabKey) {
      this.active_tab = tabKey;
    },
    setActiveTab(activeTabName){
      this.active_tab = activeTabName
    },
    toggleSideBar() {
      this.toggleSideBar()
    },
    closeSideBar() {
      this.closeSideBar()
    },
    handleResize() {
      this.resizeWidth()
      this.width = window.innerWidth;
      this.height = window.innerHeight;
    },
    changeLanguage(lang) {
      loadLanaguageAsync(lang);
    }
  }
}
</script>

<style lang="scss">

.app-main {
  display: flex;
  flex-direction: column;

}

.row {
  margin: -6px
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0
}

</style>
